import React from 'react';
import NavigationCancel from 'material-ui/svg-icons/navigation/cancel';
import FlatButton from 'material-ui/FlatButton';
import css from './chip.css';
import { grey100, grey600, grey700 } from 'material-ui/styles/colors';

function Chip(props) {
  const buttonStyle = Object.assign({}, props.style, {
    borderRadius: '20px',
    lineHeight: '34px',
  });

  return (
    <FlatButton
      label={props.label}
      labelPosition="before"
      style={buttonStyle}
      icon={<NavigationCancel />}
      onTouchTap={props.onCancel}
      backgroundColor={grey100}
    />
  );
}

export default Chip;



/** WEBPACK FOOTER **
 ** ./components/Chip.js
 **/